/**
 * Plateforme vers laquelle une invitation renvoie le répondant pour y déposer son avis.
 *
 * `OTHER` couvre les plateformes que l'application ne connaît pas nommément : elles n'ont pas de
 * logo propre, et se présentent sous un dessin générique.
 */
export enum TargetPlatformReview {
    GOOGLE = 'GOOGLE',
    TRIPADVISOR = 'TRIPADVISOR',
    TRUSTPILOT = 'TRUSTPILOT',
    OTHER = 'OTHER',
}
